export enum AdvertiserVisibility {
  ALL_USERS = 0,
  ALL_VERIFIED_USERS = 2,
  ALL_SELECTED_USERS = 1,
}
